module.exports = __webpack_public_path__ + "fe1a78fe2180663e839687ac73f5450d.pdf";